"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var baseProps_1 = require("../assets/baseProps");

var withStyles_1 = require("../decorators/withStyles");

var Overlay_1 = __importDefault(require("../utils/Overlay"));

var View_1 = __importDefault(require("../View/View"));

var Dropdown_styles_1 = require("./Dropdown.styles");

var DropdownManager_1 = __importDefault(require("./DropdownManager"));

var Dropdown =
/** @class */
function (_super) {
  __extends(Dropdown, _super);

  function Dropdown() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderContainer = function (_a) {
      var _b;

      var areaJsx = _a.areaJsx,
          overlayJsx = _a.overlayJsx,
          onClickSelfAndOutside = _a.onClickSelfAndOutside;
      return react_1.default.createElement(View_1.default, __assign({}, _this.props, {
        className: classnames_1.default(_this.props.classes.dropdown, (_b = {}, _b[_this.props.classes.textMixin] = _this.props.mode === 'text', _b)),
        onClickSelf: onClickSelfAndOutside,
        onClickOutside: onClickSelfAndOutside
      }), areaJsx, overlayJsx);
    };

    _this.renderArea = function (_a) {
      var _b;

      var onClick = _a.onClick,
          open = _a.open;
      var _c = _this.props,
          children = _c.children,
          classes = _c.classes,
          mode = _c.mode;
      return react_1.default.createElement("div", {
        className: classnames_1.default(classes.underlay, (_b = {}, _b[_this.props.classes.textMixin] = mode === 'text', _b)),
        onClick: onClick,
        ref: function ref(element) {
          _this.underlay = element;
        }
      }, typeof children === 'function' ? children(open) : children);
    };

    _this.renderOverlay = function (overlayOptions) {
      var _a = _this.props,
          overlay = _a.overlay,
          classes = _a.classes,
          overlayContainer = _a.overlayContainer,
          pureOverlay = _a.pureOverlay,
          autoOverflow = _a.autoOverflow,
          minOverlayHeight = _a.minOverlayHeight,
          reservePlacement = _a.reservePlacement,
          alwaysAdjustOverlay = _a.alwaysAdjustOverlay,
          customScroll = _a.customScroll;
      return react_1.default.createElement(Overlay_1.default, {
        placement: _this.props.placement,
        underlayElement: _this.underlay,
        container: overlayContainer,
        autoOverflow: autoOverflow,
        minHeight: minOverlayHeight,
        reservePlacement: reservePlacement,
        mode: 'dropdown',
        alwaysAdjust: alwaysAdjustOverlay,
        customScroll: customScroll
      }, react_1.default.createElement("div", {
        className: pureOverlay ? '' : classes.overlayContent
      }, baseProps_1.functionalProp(overlay, overlayOptions)));
    };

    return _this;
  }

  Dropdown.prototype.componentDidMount = function () {
    this.forceUpdate();
  };

  Dropdown.prototype.render = function () {
    var onChangeExpandState = this.props.onChangeExpandState;

    var _a = this,
        renderContainer = _a.renderContainer,
        renderArea = _a.renderArea,
        renderOverlay = _a.renderOverlay;

    return react_1.default.createElement(DropdownManager_1.default, {
      open: this.props.open,
      renderContainer: renderContainer,
      renderArea: renderArea,
      renderOverlay: renderOverlay,
      onChangeExpandState: onChangeExpandState
    });
  };

  Dropdown.defaultProps = {
    mode: 'normal'
  };
  Dropdown = __decorate([withStyles_1.withStyles(Dropdown_styles_1.dropdownStyles)], Dropdown);
  return Dropdown;
}(react_1.default.Component);

exports.default = Dropdown;